
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.8065 7.52664L8.47313 4.1933C8.40973 4.13261 8.33497 4.08503 8.25313 4.0533C8.09082 3.98663 7.90877 3.98663 7.74646 4.0533C7.66463 4.08503 7.58987 4.13261 7.52646 4.1933L4.19313 7.52664C4.13097 7.5888 4.08167 7.66259 4.04803 7.74381C4.01438 7.82502 3.99707 7.91207 3.99707 7.99997C3.99707 8.17751 4.0676 8.34777 4.19313 8.47331C4.31867 8.59884 4.48893 8.66937 4.66646 8.66937C4.844 8.66937 5.01426 8.59884 5.1398 8.47331L7.33313 6.2733V11.3333C7.33313 11.5101 7.40337 11.6797 7.52839 11.8047C7.65342 11.9297 7.82299 12 7.9998 12C8.17661 12 8.34618 11.9297 8.4712 11.8047C8.59623 11.6797 8.66646 11.5101 8.66646 11.3333V6.2733L10.8598 8.47331C10.9218 8.53579 10.9955 8.58539 11.0767 8.61923C11.158 8.65308 11.2451 8.6705 11.3331 8.6705C11.4211 8.6705 11.5083 8.65308 11.5895 8.61923C11.6708 8.58539 11.7445 8.53579 11.8065 8.47331C11.8689 8.41133 11.9185 8.3376 11.9524 8.25636C11.9862 8.17512 12.0037 8.08798 12.0037 7.99997C12.0037 7.91196 11.9862 7.82483 11.9524 7.74359C11.9185 7.66235 11.8689 7.58861 11.8065 7.52664Z","fill":"currentColor"}})])
          )
        }
      }
    